const menuItem = {
  backgroundColor: 'white'
};
export default menuItem;
